(function () {
  function getProductIdsInCart(cart) {
    return new Set((cart?.items || []).map((item) => String(item.product_id)));
  }

  function setButtonAdded(button, isAdded) {
    if (!button) {
      return;
    }

    const defaultIcon = button.querySelector('.cpg-product-card__cart-icon--default');
    const addedIcon = button.querySelector('.cpg-product-card__cart-icon--added');
    const addLabel = button.getAttribute('data-add-label');
    const addedLabel = button.getAttribute('data-added-label');

    if (isAdded) {
      button.classList.add('is-added');
      button.setAttribute('data-cpg-added', 'true');

      if (addedLabel) {
        button.setAttribute('aria-label', addedLabel);
      }

      if (defaultIcon) {
        defaultIcon.hidden = true;
      }

      if (addedIcon) {
        addedIcon.hidden = false;
      }

      return;
    }

    button.classList.remove('is-added');
    button.removeAttribute('data-cpg-added');

    if (addLabel) {
      button.setAttribute('aria-label', addLabel);
    }

    if (defaultIcon) {
      defaultIcon.hidden = false;
    }

    if (addedIcon) {
      addedIcon.hidden = true;
    }
  }

  function syncCartButtons(cart, root = document) {
    const productIds = getProductIdsInCart(cart);
    const scope = root instanceof Element ? root : document;

    scope.querySelectorAll('[data-cpg-product-id]').forEach((card) => {
      const productId = card.getAttribute('data-cpg-product-id');
      const button = card.querySelector('[data-cpg-cart-button]');

      if (!productId || !button) {
        return;
      }

      setButtonAdded(button, productIds.has(String(productId)));
    });
  }

  async function refreshCartButtons(root = document) {
    if (!window.Shopify?.routes?.root) {
      return;
    }

    try {
      const cart = await fetch(`${Shopify.routes.root}cart.js`).then((response) => response.json());
      syncCartButtons(cart, root);
    } catch (error) {
      console.error('Custom product grid: unable to refresh cart state', error);
    }
  }

  function handleCartUpdate(event) {
    if (event.detail?.cart) {
      syncCartButtons(event.detail.cart);
      return;
    }

    refreshCartButtons();
  }

  function bindCartForms(section) {
    section.querySelectorAll('.cpg-product-card__cart-form[is="product-form"]').forEach((form) => {
      if (form.dataset.cpgFormBound === 'true') {
        return;
      }

      form.dataset.cpgFormBound = 'true';

      const button = form.querySelector('[data-cpg-cart-button]');
      if (button && !button.getAttribute('data-add-label')) {
        button.setAttribute('data-add-label', button.getAttribute('aria-label') || 'Add to cart');
      }

      form.addEventListener('variant:add', handleCartUpdate);
    });

    section.querySelectorAll('quick-buy-drawer').forEach((drawer) => {
      if (drawer.dataset.cpgDrawerBound === 'true') {
        return;
      }

      drawer.dataset.cpgDrawerBound = 'true';
      drawer.addEventListener('variant:add', handleCartUpdate);
    });
  }

  function initCustomProductGrid(section) {
    if (!section) {
      return;
    }

    bindCartForms(section);
    refreshCartButtons(section);
  }

  function initAllCustomProductGrids(root = document) {
    root.querySelectorAll('.shopify-section--custom-product-grid').forEach(initCustomProductGrid);
  }

  document.addEventListener('variant:add', handleCartUpdate);
  document.documentElement.addEventListener('cart:change', handleCartUpdate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllCustomProductGrids());
  } else {
    initAllCustomProductGrids();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCustomProductGrid(event.target);
  });

  document.addEventListener('facet:update', () => {
    requestAnimationFrame(() => initAllCustomProductGrids());
  });
})();
